/** Alternative colors are lighter. */
export const pcpBluePalette = {
    foregroundLight: ' #2F97FA',
    foregroundLightAlternative: ' #8B89FB',
    /** Primary color for pcp theme. */
    foregroundDark: ' #1088F9',
    foregroundDarkAlternative: ' #7673FB',
}